import React,{useEffect,useState} from "react";
import firebase from '../../../config/firebase'
import {CATEGORIES} from '../../../Utils'
import './style.css'

function EmailContent({filtered_data,selected_newsLetter}) {
    const [data,setData] = useState([])
    useEffect(()=>{
        let arr = []
        if(selected_newsLetter){
          console.log('news letter sy',selected_newsLetter)
          // setData(selected_newsLetter)
          return
        }
        CATEGORIES.forEach(  (cat,index) => {
          console.log('api sy',selected_newsLetter)
            let set_limit = 2;
            let db_data  =  firebase.firestore().collection("jobs").where('category', '==', cat.name )
            .where('status','==','active').orderBy('postedAt', 'desc').limit(set_limit).get()
        
            .then(  result=>{
              if(result.empty){
                // res.status(404).send('not found')
                console.log('not found')
              }else{
                 result.forEach((doc,ind) => {
                  let data_res = doc.data()
                   arr.push(doc.data())
                   console.log(CATEGORIES.length-1 === index ,'inner',arr.length,CATEGORIES.length*2)
                   if((arr.length === (CATEGORIES.length * set_limit) )  ){
                    console.log('sender',CATEGORIES.length,index)
                    // res.send(arr)
                    setData(arr)
                    filtered_data(arr)
                  }
              
              })
              }
            //   console.log(arr)

            })
            .catch(err=>console.log(err.message))
        
        })
        
    },[])
  return (
    <>
      <table
        class="email-wrapper"
        width="100%"
        cellpadding="0"
        cellspacing="0"
        role="presentation"
      >
        <tr>
          <td align="center">
            <table
              class="email-content"
              width="100%"
              cellpadding="0"
              cellspacing="0"
              role="presentation"
            >
              <tr class="main_body">
                <td
                  class="email-body"
                  width="570"
                  cellpadding="0"
                  cellspacing="0"
                >
                  <table
                    class="email-body_inner"
                    align="center"
                    width="570"
                    cellpadding="0"
                    cellspacing="0"
                    role="presentation"
                  >
                    <tr>
                      <td class="content-cell">
                        <div class="f-fallback">
                          <div class="_header">
                            <img
                              width="550"
                              height="80"
                              src="https://firebasestorage.googleapis.com/v0/b/heyremote-6db3c.appspot.com/o/png-heyRemote-01.png?alt=media&token=b6fc66a9-fb0c-4df8-ac00-409aaa0da057"
                            />
                            <p class="new_jobs main_title">
                              Here's Weekly{" "}
                              <span class="_seperate"> remote jobs </span>{" "}
                            </p>{" "}
                          </div>
                          <hr />
                          <table
                            class="body-action"
                            align="center"
                            width="100%"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                          ></table>
                        {data.length>0? data.map((job,index) => {
                            return (
                                <table
                                class="attributes"
                                width="100%"
                                cellpadding="0"
                                cellspacing="0"
                                role="presentation"
                              >
                                <tr class="items">
                                  <td class="attributes_content">
                                    <table
                                      width="100%"
                                      cellpadding="0"
                                      cellspacing="0"
                                      role="presentation"
                                    >
                                      <tr>
                                        <td class="attributes_item">
                                          <div className="divider">
                                            <div
                                              style={{maxWidth:"20%"}}
                                              class="first_divider"
                                            >
                                              <span class="f-fallback image_parent">
                                                <img
                                                  class="data_image"
                                                  width="50"
                                                  height="50"
                                                  alt="Jobs Image"
                                                  src={job.company.logo}
                                                />
                                              </span>
                                            </div>
                                            <div
                                              style={{textAlign: "left",maxWidth:"70%"}}
                                              class="first_divider"
                                            >
                                              <span>
                                                <strong>
                                                  <a
                                                    class="main_title"
                                                    href={`https://heyremote.io/job/${job.id}-${job.title}`}
                                                    target='_blank'
                                                  >
                                                    {job.title} {" "}
                                                  </a>{" "}
                                                </strong>{" "}<br/>
                                               <span>
                                                    {job.location}{" "}
                                               </span>
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
    
                            )
                        })
                        :
                        (
                            <p>Loading ....</p>
                        )
                    }
                          <table
                            class="attributes"
                            width="100%"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                          >
                            <tr class="items">
                              <td class="attributes_content">
                                <table
                                  width="100%"
                                  cellpadding="0"
                                  cellspacing="0"
                                  role="presentation"
                                >
                                  <tr>
                                    <td class="attributes_item">
                                      <div class="divider">
                                        <div
                                          style={{maxWidth:"20%"}}
                                          class="first_divider"
                                        >
                                          <span class="f-fallback image_parent">
                                            <img
                                              class="data_image"
                                              width="50"
                                              height="50"
                                              alt="Jobs Image"
                                              src="https://firebasestorage.googleapis.com/v0/b/heyremote-6db3c.appspot.com/o/png-02-heyremote-orange-logo.png?alt=media&token=5fda89f6-ea76-46a3-820a-ce33f0065bc3"
                                            />
                                          </span>
                                        </div>
                                        <div
                                          style={{textAlign:"left",maxWidth:"70%"}}
                                          class="first_divider"
                                        >
                                          <span>
                                            <strong>
                                              <a
                                                class="main_title"
                                                href="https://heyremote.io/post-job"
                                                target='_blank'
                                              >
                                                {" "}
                                                Post a Job{" "}
                                              </a>{" "}
                                            </strong>{" "}
                                            <br />
                                            <span class="main_title">
                                              Post a job on{" "}
                                              <span class="_seperate">
                                                {" "}
                                                heyremote.io{" "}
                                              </span>{" "}
                                              and reach thousand of remote
                                              workers
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>

                          <table
                            class="attributes"
                            width="100%"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                          >
                            <tr class="items">
                              <td class="attributes_content">
                                <table
                                  width="100%"
                                  cellpadding="0"
                                  cellspacing="0"
                                  role="presentation"
                                >
                                  <tr>
                                    <td class="attributes_item">
                                      <div class="divider">
                                        <div
                                          style={{maxWidth:"20%"}}
                                          class="first_divider"
                                        >
                                          <span class="f-fallback image_parent">
                                            <img
                                              class="data_image"
                                              width="50"
                                              height="50"
                                              alt="Jobs Image"
                                              src="https://firebasestorage.googleapis.com/v0/b/heyremote-6db3c.appspot.com/o/denovers-logo-01.png?alt=media&token=02b2a2a0-931b-4597-8ce5-0aeb3b7e8e41"
                                            />
                                          </span>
                                        </div>
                                        <div
                                          style={{textAlign: "left",maxWidth:"70%"}}
                                          class="first_divider"
                                        >
                                          <span>
                                            <strong>
                                              <a
                                                class="main_title"
                                                href="https://denovers.com/"
                                                target='_blank'
                                              >
                                                {" "}
                                                Denovers{" "}
                                              </a>{" "}
                                            </strong>{" "}
                                            <br />
                                            <span class="main_title">
                                              B2B UI/UX Designing and frontend
                                              engineering
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>

                          <table class="body-sub" role="presentation">
                            <tr>
                              <td>
                                <p class="f-fallback sub footer_para main_title">
                                  That's all we have for you today. Good luck
                                  with your Job Hunting!
                                  <p class="see_more main_title">
                                    {" "}
                                    <a href="https://heyremote.io" target='_blank'>
                                      {" "}
                                      See more jobs{" "}
                                    </a>{" "}
                                  </p>
                                </p>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              {/* <tr>
                <td>
                  <table
                    class="email-footer"
                    align="center"
                    width="570"
                    cellpadding="0"
                    cellspacing="0"
                    role="presentation"
                  >
                    <tr>
                      <td class="content-cell" align="center">
                        <p class="f-fallback sub align-center main_title">
                          &copy; 2020 heyremote. All rights reserved.
                        </p>
                        <p class="f-fallback sub align-center main_title">
                          Denovers Technologies, LLC
                          <br />
                          410 E Santa Clara Street.
                          <br />
                          Unit #1042
                          <br />
                          San Jose, CA 95113
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
           */}
            </table>
          </td>
       
        </tr>
    
      </table>
    </>
  );
}

export default EmailContent;
